import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchSituationCategory, fetchedSituationCategory } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchSituationCategory>;

export function* getSituationCategorySaga({ meta: { callback } }: FetchActionPayload) {
  const { getSituationCategory } = getAPI();
  // TODO: add type response: YieldOf<typeof getSituationCategory> ===> then fix issues between the callApi and the action that uses data
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const response = yield call(getSituationCategory);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedSituationCategory(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedSituationCategory(undefined, error));
  }

  if (callback) callback();
}

export default function* situationCategorySaga() {
  yield takeLatest(fetchSituationCategory.type, getSituationCategorySaga);
}
